<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d12e289"><a href="#/Morr_9780310252344_epub_c3d_r1#d12e177" id="d12e290">PART ONE</a></p>
<p class="ser"><img alt="0310252342_content_0009_004" id="d12e292" src="images/0310252342_content_0009_004.jpg"/></p><p class="h1" id="d12e293"><i>A Romance for a Doctor</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morr_9780310252344_epub_c5_r1.vue?27ebef39